var r=function(r){return r.replace(/\\n/g,"<br />")};export{r as default};
//# sourceMappingURL=newLineToBreakTag.mjs.map
